'use client';

import { usePathname } from 'next/navigation';
import YotpoStars from '@/components/global/yotpo/YotpoStars';

const STORE_BASE_URL = 'https://birchliving.com';
const REVIEWS_ANCHOR = 'yotpo_product_reviews';

export default function ProductCardStars({ productId, productPath }) {
  const pathname = usePathname();

  if (!productId || !productPath || productPath === '#') return null;

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (pathname === productPath) {
      document.getElementById(REVIEWS_ANCHOR)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = `${productPath}#${REVIEWS_ANCHOR}`;
    }
  };

  return (
    <div onClickCapture={handleClick} className="cursor-pointer">
      <YotpoStars
        productId={productId}
        url={`${STORE_BASE_URL}${productPath}`}
      />
    </div>
  );
}
